<template>
    <v-overlay :value="loading" absolute>
      <v-row>
        <v-col class="text-center">
          <v-img v-if="isAuthenticating"
            contain
            src="@/assets/padlock.gif"
            max-height="50"
            transition="scale-transition"
          />
          <v-img v-else
            contain
            src="@/assets/loading.gif"
            max-height="50"
            transition="scale-transition"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center"> {{ text }} </v-col>
      </v-row>
    </v-overlay>
</template>

<script>
export default {
  // props: ['loading', 'src', 'text'],
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
    isAuthenticating: {
      type: Boolean,
      required: true,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
